import { useTranslations } from "use-intl";

export function ProDriverGraphic() {
  const t = useTranslations("proDriver.empty");

  const avatars = [
    { cx: 160, highlighted: false },
    { cx: 260, highlighted: true },
    { cx: 360, highlighted: false },
  ];
  const avatarY = 80;

  return (
    <div className="rounded-xl bg-gray-50 p-4">
      <svg
        viewBox="0 0 520 150"
        className="w-full"
        role="img"
        aria-label={t("subtitle")}
      >
        {avatars.map(({ cx, highlighted }) => (
          <Avatar key={cx} cx={cx} cy={avatarY} highlighted={highlighted} />
        ))}

        <g>
          <rect
            x={260 - 52}
            y={10}
            width={104}
            height={26}
            rx={13}
            fill="#10b981"
          />
          <text
            x={260}
            y={27}
            textAnchor="middle"
            fontSize={13}
            fontWeight={600}
            fill="#ffffff"
          >
            {t("graphicLabel")}
          </text>
          <path d="M 254 36 L 266 36 L 260 44 z" fill="#10b981" />
        </g>
      </svg>
    </div>
  );
}

function Avatar({
  cx,
  cy,
  highlighted,
}: {
  cx: number;
  cy: number;
  highlighted: boolean;
}) {
  const ring = highlighted ? "#10b981" : "#e2e8f0";
  const fill = highlighted ? "#ecfdf5" : "#f1f5f9";
  const figure = highlighted ? "#059669" : "#94a3b8";

  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={32}
        fill={fill}
        stroke={ring}
        strokeWidth={2}
        strokeDasharray={highlighted ? undefined : "5 4"}
      />
      <circle cx={cx} cy={cy - 8} r={10} fill={figure} />
      <path
        d={`M ${cx - 18} ${cy + 22} q 0 -18 18 -18 q 18 0 18 18 z`}
        fill={figure}
      />
    </g>
  );
}
